module.exports = __webpack_public_path__ + "static/media/social_icon_linkedin.02ec16b9.svg";